import ProfileDetail from "../Components/ProfileDetail";
import InternData from "../Components/InternData";
import ActivityLog from "../Components/ActivityLog";

const Profile = () => {
  const getUsername = localStorage.getItem("username");
  // const getUsername = 55050419;

  return (
    <main className="content">
      <div className="container-fluid p-0">
        <h1 className="h3 mb-3">Profile</h1>
        <div className="row">
          <div className="col-md-6">
            <ProfileDetail st_id={getUsername} />
            <InternData st_id={getUsername} />
          </div>
          <div className="col-md-6">
            <ActivityLog />
          </div>
        </div>
      </div>
    </main>
  );
};

export default Profile;
